import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Leaf, Loader2 } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error("E-posta ve şifre giriniz");
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Hoş geldiniz");
      nav("/");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Giriş yapılamadı";
      toast.error(typeof msg === "string" ? msg : "Giriş yapılamadı");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F6F3EC] px-4" data-testid="login-page">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl border border-[#E8E2D0] p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="size-11 rounded-2xl bg-[#2F5D3D] flex items-center justify-center">
            <Leaf className="size-5 text-white" />
          </div>
          <div>
            <div className="text-lg font-semibold tracking-tight">Karbon İzi</div>
            <div className="text-xs text-muted-foreground">ISO 14064-1:2018</div>
          </div>
        </div>

        <h1 className="text-2xl font-semibold mb-1">Giriş Yap</h1>
        <p className="text-sm text-muted-foreground mb-6">Hesabınıza erişmek için bilgilerinizi girin.</p>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label htmlFor="email">E-posta</Label>
            <Input id="email" type="email" autoComplete="email" value={email}
                   onChange={(e) => setEmail(e.target.value)}
                   className="mt-1.5" data-testid="login-email" />
          </div>
          <div>
            <Label htmlFor="password">Şifre</Label>
            <Input id="password" type="password" autoComplete="current-password" value={password}
                   onChange={(e) => setPassword(e.target.value)}
                   className="mt-1.5" data-testid="login-password" />
          </div>
          <Button type="submit" className="w-full rounded-full gap-2 bg-[#2F5D3D] hover:bg-[#264b31]"
                  disabled={busy} data-testid="login-submit">
            {busy ? <Loader2 className="size-4 animate-spin" /> : null}
            Giriş Yap
          </Button>
        </form>
      </div>
    </div>
  );
}
